import releases from '../whatsnew.json';
import type { ReleaseNotes } from './install';

// "What's new": after the app updates itself, the bell shows what this release added until it's
// been seen, and keeps it for a few days after that. The notes are part of the build
// (src/whatsnew.json, newest first), so the page always knows what it is running.

const KEY = 'vb.whatsNew';
const KEEP_MS = 3 * 24 * 3600_000;

export const currentNotes = (releases as ReleaseNotes[])[0] ?? null;

/** These notes, with when this device first ran them, or null once they're old news here. */
export function whatsNew(): { notes: ReleaseNotes; since: number } | null {
  if (!currentNotes) return null;
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null') as { id: string; since: number } | null;
    if (saved?.id === currentNotes.id) return Date.now() - saved.since < KEEP_MS ? { notes: currentNotes, since: saved.since } : null;
    const since = Date.now();
    localStorage.setItem(KEY, JSON.stringify({ id: currentNotes.id, since }));
    return { notes: currentNotes, since };
  } catch {
    return null; // storage blocked: skip rather than show it on every load
  }
}
